// @copyright 2006 - 2021 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'tenant.page.title': 'Organizations',
    'tenant.page.archive.title': 'Archived Organizations',
    'tenant.page.bin.title': 'Deleted Organizations',
    'tenant.page.search_results': 'Search Results',
    'tenant.page.create.title': 'Create New Organization',
    'tenant.page.search.title': 'Find Organizations',
    'tenant.page.edit.title': 'Edit Organization',
    'tenant.page.view.title': 'View Organization',
    'tenant.page.all': 'All',

    'tenant.button.cancel': 'Cancel',
    'tenant.button.select': 'Select',
    'tenant.button.find': 'Find Organizations',
    'tenant.button.search': 'Apply',
    'tenant.button.create': 'Create Organization',
    'tenant.button.new': 'New Organization',
    'tenant.button.save': 'Save Changes',
    'tenant.button.archive': 'Archive',
    'tenant.button.bin': 'Move to Bin',
    'tenant.button.delete': 'Delete',
    'tenant.button.edit': 'Edit',
    'tenant.button.restore': 'Restore',
    'tenant.button.empty': 'Empty Bin',
    'tenant.button.reset': 'Reset',
    'tenant.button.next': 'Next',
    'tenant.button.sign_up': 'Sign Up',

    'tenant.link.create_first_tenant': 'Click here to create your first tenant',
    'tenant.link.Organizations': ' Return to Organizations',
    'tenant.link.bin': 'Bin',
    'tenant.link.archive': 'Archive',
    'tenant.link.retry': 'Click here to retry',

    'tenant.checkbox.all': 'Check All',
    'tenant.checkbox.actions_label': 'with selected',

    'tenant.label.subscription': 'Subscription',
    'tenant.label.profile': 'Organization Profile',

    'tenant.label.plan_id': 'Plan',
    'tenant.label.plan_price_id': 'Period',
    'tenant.label.plan_pricing_id': 'Pricing',
    'tenant.label.tenant_name': 'Organization Name',
    'tenant.label.tenant_email': 'Organization Email',
    'tenant.label.tenant_billing_email': 'Organization Billing Email',
    'tenant.label.tenant_website': 'Organization Website',
    'tenant.label.tenant_logo_path': 'Organization Logo Path',
    'tenant.label.telephone_number': 'Telephone Number',
    'tenant.label.address_line_1': 'Address Line 1',
    'tenant.label.address_line_2': 'Address Line 2',
    'tenant.label.province': 'Province',
    'tenant.label.postal_code': 'Postal Code',
    'tenant.label.country_name': 'Country',
    'tenant.label.jurisdiction_name': 'Jurisdiction',
    'tenant.label.locale': 'Locale',
    'tenant.label.timezone_list_name': 'Timezone',
    'tenant.label.is_indirect_tax_registered': 'Registered to collect GCT?',
    'tenant.label.application_code': 'Application Code',
    'tenant.label.application_sub_code': 'Application Sub Code',
    'tenant.label.created_at': 'Created At',
    'tenant.label.created_by_username': 'Created By Username',
    'tenant.label.updated_at': 'Updated At',
    'tenant.label.updated_by_username': 'Updated By Username',
    'tenant.label.deleted_at': 'Deleted At',
    'tenant.label.deleted_by_username': 'Deleted By Username',
    'tenant.label.status': 'Status',
    'tenant.label.use_system_rates': ' Use HeadOffice Exchange Rates (recommended)',
    'tenant.label.use_custom_rates': 'I will add my own Exchange Rates',
    'tenant.label.rate_update_frequency': 'Frequency of updates (in days) ',

    'tenant.label.tax_id': 'Tax ID',
    'tenant.label.jurisdiction_id': 'Jurisdiction',
    'tenant.label.jurisdiction_details': 'Jurisdiction Details',
    'tenant.label.reporting_currency_id': 'Reporting Currency',
    'tenant.label.financial_year_start_month': 'First Month of the Financial Year',
    'tenant.label.industry_type_id': 'Industry Type',

    'tenant.label.payment_details': 'Payment Details',
    'tenant.label.name_on_card': 'Name on Card',

    'tenant.sort.field_label': 'Field',
    'tenant.sort.direction_label': 'Direction',
    'tenant.sort.direction_ascending': 'Ascending',
    'tenant.sort.direction_descending': 'Descending',

    'tenant.modal.title.tenant_archive': 'Archive Tenant',
    'tenant.modal.title.tenant_delete': 'Move To Bin',
    'tenant.modal.title.tenant_delete_permanently': 'Delete Tenant',
    'tenant.modal.title.tenant_restore': 'Restore Tenant',
    'tenant.modal.title.tenant_delete_permanently_all': 'Clear Organizations Bin',

    'tenant.modal.message.tenant_archive': 'Are you sure that you want to archive this tenant? | Are you sure that you want to archive these organizations?',
    'tenant.modal.message.tenant_delete': 'Are you sure that you want to move this tenant to the bin? | Are you sure that you want to move these organizations to the bin?',

    'tenant.modal.message.tenant_permanently_delete':
        'Are you sure that you want to permanently delete this tenant? This action cannot be undone. | Are you sure that you want to permanently delete these organizations? This action cannot be undone.',
    'tenant.modal.message.tenant_restore': 'Are you sure that you want to restore this tenant? | Are you sure that you want to restore these organizations?',
    'tenant.modal.message.tenant_bin_empty': 'Are you sure that you want to permanently delete all organizations in the bin? This action cannot be undone!',

    'tenant.success.message.tenant_created': 'Your organization has been created',
    'tenant.success.message.tenant_updated': 'Your organization has been updated',
    'tenant.success.message.tenant_binned': 'Your tenant was moved to the bin | All selected organizations were moved to the bin',
    'tenant.success.message.tenant_archived': 'Your tenant has been archived | All selected organizations were archived',
    'tenant.success.message.tenant_restored': 'Your tenant has been restored | All selected organizations were restored',
    'tenant.success.message.tenant_deleted': 'Your tenant has been permanently deleted | All selected organizations were permanently deleted',
    'tenant.success.message.tenant_bin_emptied': 'All organizations were permanently deleted from the bin!',

    'tenant.error.message.tenant_binned': 'This tenant was already moved to the bin | These organizations were already moved to the bin',
    'tenant.error.message.tenant_deleted': 'This tenant was already permanently deleted | These organizations were already permanently deleted',
    'tenant.error.message.tenant_archived': 'This tenant was already archived | These organizations were already archived',
    'tenant.error.message.tenant_restored': 'This tenant was already restored | These organizations were already restored',
    'tenant.error.message.tenant_bin_emptied': 'This bin was already emptied',
    'tenant.error.message.error_loading_page': 'Sorry, there was an error loading tenant.| Sorry, there was an error loading organizations.',

    'tenant.activation.message.activating_message': 'Accepting invitation, one moment please',
    'tenant.activation.message.success': 'Your were successfully added to the team!',
    'tenant.activation.message.error': 'There was an error accepting this invitation. Please contact the sender for assistance.',

    'tenant.field.organization_name': 'Organization Name',
    'tenant.field.vanity_url': 'URL Slug',
    'tenant.field.email': 'Email',
    'tenant.field.billing_email': 'Billing Email',
    'tenant.field.website': 'Website',
    'tenant.field.phone': 'Phone',
    'tenant.field.address_line_1': 'Address Line 1',
    'tenant.field.address_line_2': 'Address Line 2',
    'tenant.field.province': 'Province',
    'tenant.field.postal_code': 'Postal Code',
    'tenant.field.country': 'Country',
    'tenant.field.timezone': 'Timezone',
    'tenant.field.jurisdiction': 'Jurisdiction',
    'tenant.field.reporting_currency': 'Reporting Currency',
    'tenant.field.industry': 'Industry',
    'tenant.field.financial_year_start_month': 'First Month of the Financial Year',
    'tenant.field.exchange_rate_preference': 'Exchange Rate Preference',
    'tenant.field.use_system_rates': 'Use system exchange rates',
    'tenant.field.use_custom_rates': 'Use custom exchange rates',
    'tenant.field.rate_update_frequency': 'Rate Update Frequency (days)',
    'tenant.field.coupon_code': 'Referral Code (optional)',
    'tenant.field.name_on_card': 'Name on Card',
    'tenant.field.card_details': 'Card Details',
    'tenant.field.trn': 'TRN',
    'tenant.field.nis': 'NIS',

    'tenant.heading.company_details': 'Company Details',
    'tenant.heading.jurisdiction': 'Jurisdiction & Financial Settings',
    'tenant.heading.payment_details': 'Payment Details',
    'tenant.heading.order_summary': 'Order Summary',

    'tenant.pricing.select_plan': 'Choose Your Plan',
    'tenant.pricing.loading': 'Loading plans...',
    'tenant.pricing.free_trial': '{days}-day free trial',
    'tenant.pricing.select_plan_error': 'Please select a plan',
    'tenant.pricing.select_billing_cycle_error': 'Please select a billing cycle',

    'tenant.payment.trial_message': 'Your card will not be charged for {days} days. You can cancel anytime during the trial period.',
    'tenant.payment.plan_label': 'Plan',
    'tenant.payment.billing_label': 'Billing',
    'tenant.payment.due_today': 'Due today',
    'tenant.payment.stripe_not_ready': 'Payment system is not ready. Please wait and try again.',
    'tenant.payment.processing_error': 'An error occurred processing your payment details.',

    'tenant.validation.organization_name_required': 'Organization name is required',
    'tenant.validation.email_required': 'Email is required',
    'tenant.validation.country_required': 'Country is required',
    'tenant.validation.timezone_required': 'Timezone is required',
    'tenant.validation.jurisdiction_required': 'Jurisdiction is required',
    'tenant.validation.reporting_currency_required': 'Reporting currency is required',
    'tenant.validation.industry_required': 'Industry is required',
    'tenant.validation.financial_year_start_month_required': 'First month of the financial year is required',

    'wizard.button.back': 'Back',
    'wizard.button.next': 'Next',
    'wizard.button.skip': 'Do it later',

    'tenant.step.company_details': 'Company Details',
    'tenant.step.jurisdiction': 'Jurisdiction',
    'tenant.step.pricing': 'Pricing',
    'tenant.step.payment': 'Payment',

    'tenant.message.created_successfully': 'Organization created successfully!',
    'tenant.error.fix_errors': 'Please fix the errors and try again.',
    'tenant.error.generic': 'An error occurred. Please try again.',

    'tenant.empty.title': 'No organizations yet',
    'tenant.empty.description': 'Create your first organization to get started with HeadOffice.',

    'tenant.payment.due_today_free': '$0.00',

    'tenant.label.coupon_code': 'Referral Code',
    'tenant.label.tenant_photo': 'Photo',
    'tenant.label.image_description': 'Upload images should be a square, recommended size 300x300',
    'tenant.label.upload': 'Click to upload or drag and drop',
    'tenant.label.upload_types': 'JPG,PNG,JPEG, Max 2MB',

    'tenant.playground.badge': 'Playground',

    'tenant.playground.banner.label': 'Playground — nothing here is real. Documents are watermarked and no email is sent.',
    'tenant.playground.banner.expires_on': 'This playground is removed on {date}.',
    'tenant.playground.banner.expires_in_days': 'This playground is removed in {days} days.',

    'tenant.playground.link.create': 'Try a playground',
    'tenant.playground.link.create_description': 'A sandbox to explore freely — nothing here is real or billed.',
    'tenant.playground.link.experimental_badge': 'Experimental',

    'tenant.playground.page.create.title': 'Create a Playground',
    'tenant.playground.page.create.checking': 'Checking whether you already have a playground…',
    'tenant.playground.page.create.check_failed': 'We could not check whether you already have a playground. Please try again.',

    'tenant.playground.page.exists.title': 'Your playground',
    'tenant.playground.summary.sample_data': 'Sample data',
    'tenant.playground.summary.market': 'Market',
    'tenant.playground.summary.removed_on': 'Removed on',
    'tenant.playground.summary.removed_on_hint': 'if left unused',
    'tenant.playground.summary.state.ready': 'Ready',
    'tenant.playground.summary.start_over_hint': 'Starting over deletes everything in this playground and rebuilds it with sample data you choose. The organisation itself, its name and its link stay the same.',

    'tenant.playground.page.start_over.title': 'Start over from scratch',
    'tenant.playground.page.start_over.warning_heading': 'Everything in this playground is deleted.',
    'tenant.playground.page.start_over.warning': 'Invoices, contacts, bank records, payroll — all of it. This cannot be undone. The organisation itself, its name and its link stay the same.',
    'tenant.playground.page.start_over.currently': 'Currently',
    'tenant.playground.page.start_over.no_playground': 'You do not have a playground to start over with.',
    'tenant.playground.page.start_over.not_permitted': 'Your account does not have permission to start this playground over.',
    'tenant.playground.preset.current_badge': 'Current',

    'tenant.playground.button.create': 'Create Playground',
    'tenant.playground.button.enter': 'Open your playground',
    'tenant.playground.button.regenerate': 'Start over',
    'tenant.playground.button.regenerate_confirm': 'Delete everything and rebuild',
    'tenant.playground.button.start_again': 'Create a new playground',
    'tenant.playground.button.start_over': 'Start over from scratch',

    'tenant.playground.step.jurisdiction.title': 'Choose a jurisdiction',
    'tenant.playground.step.jurisdiction.description': 'Your playground is set up with the taxes, currency and rules of the market you choose.',
    'tenant.playground.step.jurisdiction.loading': 'Loading jurisdictions…',
    'tenant.playground.step.jurisdiction.error': 'The list of jurisdictions could not be loaded.',
    'tenant.playground.step.preset.title': 'Choose sample data',
    'tenant.playground.step.preset.description': 'Start from nothing, or explore a fully worked example business.',

    'tenant.playground.preset.group_label': 'Choose what to fill your playground with',
    'tenant.playground.preset.loading': 'Loading presets…',
    'tenant.playground.preset.error': 'The list of presets could not be loaded.',

    'tenant.playground.preset.blank.name': 'Empty',
    'tenant.playground.preset.blank.description': 'A fully set-up organisation with no data — start from nothing.',
    'tenant.playground.preset.bookstore.name': 'Bookstore',
    'tenant.playground.preset.bookstore.description': 'A retail bookshop with stock, suppliers and counter sales.',
    'tenant.playground.preset.medical.name': 'Medical practice',
    'tenant.playground.preset.medical.description': 'A private medical practice with patients, consultations and billing.',
    'tenant.playground.preset.plumber.name': 'Plumber',
    'tenant.playground.preset.plumber.description': 'A trade business quoting and invoicing plumbing jobs, with parts and suppliers.',
    'tenant.playground.preset.professional-services.name': 'Professional services',
    'tenant.playground.preset.professional-services.description': 'A consultancy billing clients for projects and time.',
    'tenant.playground.preset.marketing.name': 'Marketing agency',
    'tenant.playground.preset.marketing.description': 'An agency running client campaigns, with projects, invoices and suppliers.',
    'tenant.playground.preset.restaurant.name': 'Restaurant',
    'tenant.playground.preset.restaurant.description': 'A restaurant with menu items, daily counter sales and food suppliers.',
    'tenant.playground.preset.refuelling.name': 'Service station',
    'tenant.playground.preset.refuelling.description': 'A fuel station with pump sales, shop stock and supplier deliveries.',

    'tenant.playground.build.in_progress': 'Your playground is being built with the {preset} sample data. This can take a few minutes.',
    'tenant.playground.build.ready': 'Your playground is ready. Taking you in…',
    'tenant.playground.build.timed_out': 'The build is taking far longer than expected and may be stuck. Regenerate to start it again.',
    'tenant.playground.build.missing': 'This playground no longer exists. It may have been removed after a period of inactivity.',
    'tenant.playground.build.unreachable': 'We could not reach the server to check on the build. Check your connection and retry.',
    'tenant.playground.build.contact_support': 'The build did not finish, and your account does not have permission to regenerate this playground. Please contact support.',

    'tenant.playground.regenerate.build_in_progress': 'A rebuild is already running. You can start over again once it finishes.',
    'tenant.playground.regenerate.rebuild_with': 'Rebuild with',
    'tenant.playground.regenerate.view_progress': 'View build progress',

    'tenant.playground.error.already_exists': 'You already have a playground. Open it, or start over to build it again.',
    'tenant.playground.error.build_in_progress': 'This playground is still being built. Wait for the build to finish before starting over.',
    'tenant.playground.error.not_a_playground': 'This action is only available in a playground.',
    'tenant.playground.error.profile_locked': 'A playground’s organisation details cannot be changed — it is always named after you.',
    'tenant.playground.error.switch_failed': 'We could not open your playground. Please try again.',
    'tenant.playground.error.email_not_sent': 'A playground never sends email, so this message was not sent.',
    'tenant.playground.error.bank_aggregator': 'Connecting a real bank account is not available in a playground.',
    'tenant.playground.error.ai_employees': 'AI employees are not available in a playground.',
    'tenant.playground.error.receipt_extraction': 'Scanning receipts is not available in a playground.',
    'tenant.playground.error.voice_calls': 'Making and receiving calls is not available in a playground.',
    'tenant.playground.error.realtime': 'Realtime connections are not available in a playground.',
    'tenant.playground.error.push': 'Push notifications are not sent from a playground.',
    'tenant.playground.error.api_tokens': 'API tokens cannot be created in a playground.',
    'tenant.playground.error.invitations': 'You cannot invite people into a playground.',
    'tenant.playground.error.jurisdiction_not_supported': 'Playgrounds are not available for this jurisdiction. Please choose another.',
    'tenant.playground.error.jurisdiction_no_plan': 'Playgrounds are not set up for this jurisdiction yet. Please choose another.',
};
